module.exports = __webpack_public_path__ + "media/images/admin/error_page_doctor-f87fad75dae801025dcc66adc2c1621f.svg";